"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const UNPROCESSABLE_ENTITY = 422;
export function isCsrfRejection(status, rejected, refreshed) {
  return status === UNPROCESSABLE_ENTITY && rejected !== null && refreshed !== null;
}
export function retryInputFor(input, request, init, headers) {
  var _a;
  if ((init == null ? void 0 : init.body) != null) {
    return typeof ReadableStream !== "undefined" && init.body instanceof ReadableStream ? null : input;
  }
  if (request === null || request.body === null) {
    return input;
  }
  if (request.bodyUsed || request.body.locked) {
    return null;
  }
  const contentType = ((_a = headers.get("content-type")) != null ? _a : "").split(";")[0].trim();
  return contentType === "application/json" ? request.clone() : null;
}
const isUpload = (body) => body instanceof FormData || body instanceof Blob;
const HIDDEN_EVENTS = [
  "loadstart",
  "progress",
  "load",
  "error",
  "abort",
  "timeout"
];
export class XhrRetry {
  constructor(xhr) {
    __publicField(this, "xhr");
    __publicField(this, "retried", false);
    __publicField(this, "rejected", false);
    __publicField(this, "replaying", false);
    __publicField(this, "attempt", null);
    this.xhr = xhr;
    for (const type of HIDDEN_EVENTS) {
      xhr.addEventListener(type, (event) => this.suppressIfRetrying(event));
    }
    xhr.addEventListener("loadend", (event) => {
      if (!this.suppressIfRetrying(event) || !this.rejected) {
        return;
      }
      const attempt = this.attempt;
      setTimeout(() => {
        if (attempt !== null && this.attempt === attempt) {
          this.rejected = false;
          this.retry(attempt);
        }
      }, 0);
    });
  }
  suppressIfRetrying(event) {
    if (!this.rejected && !this.replaying) {
      return false;
    }
    event.stopImmediatePropagation();
    return true;
  }
  recordOpen(open) {
    this.retried = false;
    this.rejected = false;
    this.attempt = { open, headers: /* @__PURE__ */ new Map(), body: null };
  }
  recordHeader(lowerName, value) {
    var _a;
    const headers = (_a = this.attempt) == null ? void 0 : _a.headers;
    const existing = headers == null ? void 0 : headers.get(lowerName);
    headers == null ? void 0 : headers.set(
      lowerName,
      existing === void 0 ? value : `${existing}, ${value}`
    );
  }
  recordBody(body) {
    if (this.attempt) {
      this.attempt.body = body;
    }
  }
  recordAbort() {
    this.rejected = false;
    this.attempt = null;
  }
  suppressAndMarkForRetry(event) {
    var _a;
    if (this.retried || isUpload((_a = this.attempt) == null ? void 0 : _a.body)) {
      return;
    }
    this.rejected = true;
    event.stopImmediatePropagation();
  }
  // Reopening and resending the same object re-fires every listener the
  // caller already attached, as if the first attempt had simply taken
  // longer — so the retry is invisible to them.
  retry({ open, headers, body }) {
    const xhr = this.xhr;
    this.replaying = true;
    try {
      xhr.open(open.method, open.url, open.async, open.username, open.password);
      this.retried = true;
      for (const [name, value] of headers) {
        xhr.setRequestHeader(name, value);
      }
      xhr.send(body);
    } finally {
      this.replaying = false;
    }
  }
}
